import React, { useEffect } from "react";

const TabLanguage = ({ name, active, index , setOpenTab }) => {
  return (
    <li className="flex text-center cursor-pointer" onClick={()=>{
        setOpenTab(index)
    }}>
      <div
        className={`text-xs font-bold uppercase px-5 py-2 shadow-lg block leading-normal ${
          active === index ? "bg-[#916C00] text-white" : ""
        }`}>
        <span>{name}</span>
      </div>
    </li>
  );
};

export default TabLanguage;
